import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FormContainer = styled(Stack)(({ theme }) => ({
  boxSizing: "border-box",
  width: 300,
  padding: theme.spacing(2),
  gap: theme.spacing(1),
}));

export const HelperText = styled(Typography)({
  minHeight: 40,
  whiteSpace: "pre-wrap",
});
